import { FormattedMessage } from 'react-intl'
import _get from 'lodash/get';
import Modal from '@/shared/ui/Modal';
import Title from '@/shared/ui/Title';
import { VIEWS, useNavigation } from "@/processes/Router";
import { WorkersChart, WorkersTable } from '~/accountingAndAnonymous/Workers';

type WorkersModalProps = {
  className?: string;
}

const WorkersModal = (props: WorkersModalProps) => {
  const { className } = props;
  const { view, updateURLQueryParams } = useNavigation();
  const isShow = view === VIEWS.WORKERS;

  const handleClose = () => {
    updateURLQueryParams({ view: null });
  };

  return (
    <Modal 
      title={
        <Title order={3} size='2xl'>
          <FormattedMessage id="workers"/>
        </Title>
      }
      show={isShow}
      onDismiss={handleClose}
      className={className} 
    >
      <WorkersChart/>
      <WorkersTable/>
    </Modal>
  );
}

export default WorkersModal;
